import { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { Button, Modal, CardContent } from '@mui/material';
import MainCard from 'components/MainCard';
import { Viewer } from '@photo-sphere-viewer/core';
import { AutorotatePlugin } from '@photo-sphere-viewer/autorotate-plugin';
import '@photo-sphere-viewer/core/index.css';
import * as exifr from 'exifr';
import { checkImageFromBlob } from 'data/data';

export function PanoViewerLayer({info, idx}) {
    const { t } = useTranslation();
  
    const [open, setOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const handleOpen = () => {
      setOpen(true);
      setImageFromFile(info.vrFiles[idx-1].file, idx-1 , 2);
    }
    const handleClose = () => setOpen(false);
    
    const [imageUrl, setImageUrl] = useState(null);
    const [is360, setIs360] = useState(null);
    const viewerRef = useRef(null);
    const containerRef = useRef(null);

    const [bpImage, setBpImage] = useState(process.env.PUBLIC_URL+"/img/floor_plan.png");
    // const [vrImage, setVrImage] = useState();
    
    useEffect(()=>{
      if (info && open) {
        if (info.bpFile) {
           setImageFromFile(info.bpFile, null, 1);
        }
        if (info.vrFiles && info.vrFiles.length > 0) {
          setImageFromFile(info.vrFiles[idx-1].file, idx-1, 2);
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[open]);

    const setImageFromFile = async( file , selectIdx, type ) => {
      const fileUrl = window.RUNTIME_CONFIG.REACT_APP_API_URL+"/api/download/"+file.id;
      if (type === 1)
        setBpImage(fileUrl);
      else {
        // setVrImage(fileUrl);
        setSelectedIndex(selectIdx);

        try {
          const response = await fetch(fileUrl); // 실제 API 주소로 변경
          const blob = await response.blob();
          const { url, is360 } = await checkImageFromBlob(blob);
          setImageUrl(url);
          setIs360(is360);
        } catch (error) {
          console.error('image file download fail:', error);
        }
      }
    };

    useEffect(() => {
      // if (is360 && imageUrl && containerRef.current) {
      if ( imageUrl && containerRef.current) {
        if (viewerRef.current) {
          viewerRef.current.destroy();
        }

        viewerRef.current = new Viewer({
          panorama: imageUrl,
          container: containerRef.current,
          // ✅ 자동 회전 활성화
          plugins: [
              [AutorotatePlugin, {
                  autostartDelay: 1000,
                  // autorotatePitch: '5deg',
                  autorotateSpeed: '1rpm',
              }],
          ],
        });
      }

      // return () => {
      //   viewerRef.current?.destroy();
      // };
    }, [is360, imageUrl]);

    return (
      <>
        <Button variant="contained" onClick={handleOpen} style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px"}} color="success">
          <span className="icon_png"><img style={{width:"20px"}} src={`${process.env.PUBLIC_URL}/img/icon/view_in_ar.png`} alt='' /></span>&nbsp;VR{idx}
        </Button>
  
        <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <MainCard style={{maxWidth:"1440px", width:"90%", height:"75vh"}} title="" modal darkTitle content={false}>
            <CardContent style={{height:"100%"}}>
              <div className='pop_close'>
                <Button color="primary" size="small" onClick={handleClose}>
                  {t('message.common.btn.close')}
                </Button>
              </div>
  
              <div className='vr_pop_box'>
                <div>
                  <p className='floor_plan'><img style={{width:"400px"}} src={bpImage} alt={t('message.common.text.drawing.image')} /></p>
                  <div>
                    <ul className='vr_pop_btn'>
                    {selectedIndex >= 0 && info && info.vrFiles && info.vrFiles.map(function(item, i) {
                        let selectedClass = '';
                        if (selectedIndex === i) {
                          selectedClass = 'on';
                        }
                        return (
                      <li key={i} onClick={()=>{setImageFromFile(item.file, i, 2)}} className={selectedClass}><span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/view_in_ar.png`} alt='' /></span>&nbsp;VR{i+1}</li>
                        )
                    })}
                    </ul>
                  </div>
                </div>
  
                <div className='player-wrapper' style={{width:"100%", height: '73vh'}}>
                  {imageUrl && /* is360 === true &&*/ (
                    <div ref={containerRef} style={{ width: '100%', height: '93%'}} />
                  )}
                  {/* {imageUrl && is360 === false && (
                    <div>
                      <img src={imageUrl} alt="uploaded" style={{ maxWidth: '100%', maxHeight: '590px' }} />
                    </div>
                  )} */}
                </div>
              </div>
            </CardContent>
  
          </MainCard>
        </Modal>
      </>
    )
  }
  
  export default PanoViewerLayer;
  